<!-- ════════════════════════════════════════════════
     VISION FOR UMMAH — HERO SLIDER
     ════════════════════════════════════════════════ -->
<div class="vfu-hero-slider-wrap">

  <swiper [config]="homeSlides" *ngIf="sliders?.length > 0; else heroFallback" #swiper>
    <ng-template swiperSlide *ngFor="let slider of sliders">

      <div class="vfu-hero" [style.background-image]="getSliderStyle(slider.img1)">
        <div class="container">
          <div class="vfu-hero-content">

            <div class="hero-eyebrow" *ngIf="slider.title">
              <span>{{ slider.title }}</span>
            </div>

            <h1 *ngIf="slider.text">{{ slider.text }}</h1>

            <p class="hero-desc" *ngIf="slider.shortText">
              {{ slider.shortText }}
            </p>

            <div class="hero-actions">
              <a routerLink="/about" class="btn btn-primary btn-lg">
                <i class='bx bx-info-circle'></i>
                {{"MENU.About" | translate}}
              </a>
              <a routerLink="/contact" class="btn btn-ghost btn-lg">
                <i class='bx bx-envelope'></i>
                {{"MENU.Contact" | translate}}
              </a>
            </div>

          </div>
        </div>
      </div>

    </ng-template>
  </swiper>

  <!-- Fallback while loading or if API returns nothing -->
  <ng-template #heroFallback>
    <div class="vfu-hero vfu-hero-static">
      <div class="container">
        <div class="vfu-hero-content">
          <div class="hero-eyebrow">
            <span>تجمع من أجل أمة</span>
          </div>
          <h1>رسالتنا نحو مستقبل أفضل</h1>
          <p class="hero-desc">نعمل معاً لبناء مجتمع قائم على القيم والمعرفة</p>
          <div class="hero-actions">
            <a routerLink="/about" class="btn btn-primary btn-lg">
              <i class='bx bx-info-circle'></i>
              {{"MENU.About" | translate}}
            </a>
            <a routerLink="/contact" class="btn btn-ghost btn-lg">
              <i class='bx bx-envelope'></i>
              {{"MENU.Contact" | translate}}
            </a>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

</div>